import { render, staticRenderFns } from "./ServiceDashboardSummaryCardLiveHelp.vue?vue&type=template&id=4abcbd67&scoped=true&"
import script from "./ServiceDashboardSummaryCardLiveHelp.vue?vue&type=script&lang=js&"
export * from "./ServiceDashboardSummaryCardLiveHelp.vue?vue&type=script&lang=js&"
import style0 from "./ServiceDashboardSummaryCardLiveHelp.vue?vue&type=style&index=0&id=4abcbd67&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4abcbd67",
  null
  
)

export default component.exports